 <template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      Insured List
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <form data-vv-scope="insuredFilterForm">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap v-if="headerInfo === 'header2'">
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="insuredFilterForm"
                            v-model="filtersFacVal.insdName"
                            :label="filtersLabel.insdName"
                            :error-messages="errors.collect('insdName')"
                            data-vv-name="insdName"
                            :data-vv-as="filtersLabel.insdName"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap v-else>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="insuredFilterForm"
                            v-model="filtersFacVal.insdRefNo"
                            :label="filtersLabel.insdRefNo"
                            :error-messages="errors.collect('insdRefNo')"
                            data-vv-name="insdRefNo"
                            :data-vv-as="filtersLabel.insdRefNo"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="insuredFilterForm"
                            v-model="filtersFacVal.insdName"
                            :label="filtersLabel.insdName"
                            :error-messages="errors.collect('insdName')"
                            data-vv-name="insdName"
                            :data-vv-as="filtersLabel.insdName"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions right>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.prevent="doFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-flex v-if="headerInfo === 'header2'" xs12 class="mt-2">
        <v-data-table
          :headers="headers2"
          :items="facValItems"
          v-bind:options.sync="paginationFacVal"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsFacVal"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.titleName }}</td>
              <td>{{ row.item.name1 }}</td>
              <td>{{ row.item.address1 }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignValue(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
      <v-flex v-else xs12 class="mt-2">
        <v-data-table
          :headers="headers1"
          :items="facValItems"
          v-bind:options.sync="paginationFacVal"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsFacVal"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.insdRefNo }}</td>
              <td>{{ row.item.name1 }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignValue(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      actionName: '',
      filtersLabel: {
        insdRefNo: 'Insured Ref No',
        insdName: 'Insured Name'
      },
      filtersFacVal: {
        insdRefNo: '',
        insdName: ''
      },
      facValItems: [],
      totalItemsFacVal: 0,
      headers1: [
        { text: 'Insured Ref No.', align: 'left', value: 'insdRefNo' },
        { text: 'Insured Name', value: 'name1' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      headers2: [
        { text: 'Title Name', align: 'left', value: 'titleName' },
        { text: 'Insured Name', value: 'name1' },
        { text: 'Address 1', value: 'address1' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationFacVal: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      addrLink: null
    }
  },
  mounted() {
    this.doClearFilters()
  },
  methods: {
    closeDialog() {
      this.filtersFacVal.insdRefNo = ''
      this.filtersFacVal.insdName = ''
      this.addrLink = null
      this.$emit('close')
    },
    doAssignUrl() {
      this.addrLink = this.$store.state.commons.menu.insuredList
    },
    doClearFilters() {
      this.filtersFacVal.insdRefNo = ''
      this.filtersFacVal.insdName = ''
      this.doAssignUrl()
      this.fetchFacValData(this.addrLink)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll('insuredFilterForm').then((result) => {
        if (result) {
          this.pagination.page = 1
          this.doAssignUrl()
          this.fetchFacValData(this.addrLink)
        }
      })
    },
    assignValue(data) {
      // Use $emit to call parent Accounts page method assignFund and pass the value
      data.insuredFieldKey = this.insuredFieldKey
      this.$emit('assign-insured-info', data)
      this.$emit('close')
    }
  },
  computed: {
    menu() {
      return this.$store.state.commons.menu
    }
  },
  watch: {
    'paginationFacVal': function (value) {
      this.fetchFacValData(this.addrLink)
    }
  },
  mixins: [TableConst.default, commonAjaxMixin],
  props: {
    insuredFieldKey: {
      type: String,
      default: ''
    },
    headerInfo: {
      type: String,
      default: ''
    },
    fieldId: {
      type: String,
      default: ''
    }
  }
}
</script>
